module.exports = __webpack_public_path__ + "assets/img/btn-view-info-d82c58bf.png";